import React from "react";
import { formatDisplayFileSize, formatFileTypeLabel } from "../../../utils/formatFileSize.js";

/**
 * Einheitlicher Fallback für nicht einbettbare / fehlerhafte Dateien.
 */
export default function UnsupportedPreviewPanel({
  fileName = "",
  ext = "",
  fileSize = null,
  message = "",
  hints = [],
}) {
  const typeLabel = formatFileTypeLabel(ext);
  const sizeLabel = formatDisplayFileSize(fileSize);

  return (
    <div
      className="rounded-xl border border-white/10 bg-white/5 p-4 space-y-3"
      data-testid="file-preview-unsupported"
    >
      <div className="space-y-1">
        {fileName ? (
          <p className="text-sm font-semibold text-blue-100/95 break-all">{fileName}</p>
        ) : null}
        <p className="text-xs text-blue-200/75">
          {typeLabel}
          {sizeLabel ? ` · ${sizeLabel}` : ""}
        </p>
      </div>

      <p className="text-sm text-blue-100/90 leading-relaxed">{message}</p>

      {hints.filter(Boolean).map((hint) => (
        <p key={hint} className="text-xs text-blue-200/75 leading-relaxed">
          {hint}
        </p>
      ))}
    </div>
  );
}
